<template>
  <div>
    <p>Обрабатывается</p>
    <UserName :id="isOrderUnderManagerProgress(orderId, true)"/>
    <div class="order_in_manager_progress">
      <time-ago
        refresh locale="ru" long :tooltip="false"
        :datetime="$ordersUnderManagerProgress[orderId][isOrderUnderManagerProgress(orderId, true)]?.time"
      />
    </div>

  </div>
</template>
<script>
import UserName from "@/components/users/UserName.vue";
import TimeAgo from "vue2-timeago";

export default {
  components: {UserName, TimeAgo},
  props: ['orderId']
}
</script>

<style>
.order_in_manager_progress .v-time-ago__text {
  font-size: 10px;
}
</style>
